import { render, staticRenderFns } from "./TechnicianItem.vue?vue&type=template&id=22f02cca"
import script from "./TechnicianItem.vue?vue&type=script&lang=js"
export * from "./TechnicianItem.vue?vue&type=script&lang=js"
import style0 from "./TechnicianItem.vue?vue&type=style&index=0&id=22f02cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports